<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<el-form-item label="短剧ID:" prop="albumId">
						<el-input v-model="formInline.albumId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search" @clear="search" style="width: 150px;"></el-input>
					</el-form-item>
					<!--<el-form-item label="绑定小程序：" prop="appid">-->
						<!--<app-list @getAppId="getAppId" :appId="formInline.appid"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button  v-has="'mediaBinding:add'" type="success" icon="el-icon-circle-plus-outline"  @click="addData">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="appid" label="绑定小程序">
					</el-table-column>
					<el-table-column prop="videoId" label="短剧ID">
					</el-table-column>
					<el-table-column prop="episodeId" label="剧集ID">
					</el-table-column>
					<el-table-column prop="path" label="小程序页面" width="320">
					</el-table-column>
					<el-table-column prop="title" label="剧名称">
					</el-table-column>
					<el-table-column prop="epNumber" label="集数" width="100">
					</el-table-column>
					<el-table-column prop="addTime" label="添加时间">
					</el-table-column>
					<el-table-column label="操作" width="250">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row)">详情</el-button>
							<el-popover v-has="'mediaBinding:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td>绑定小程序</td>
						<td>{{rowForm.appid}}</td>
					</tr>
					<tr>
						<td>短剧ID</td>
						<td>{{rowForm.videoId}}</td>
					</tr>
					<tr>
						<td>剧集ID</td>
						<td>{{rowForm.episodeId}}</td>
					</tr>
					<tr>
						<td>小程序页面</td>
						<td>{{rowForm.path}}</td>
					</tr>
					<tr>
						<td>剧名称</td>
						<td>{{rowForm.title}}</td>
					</tr>
					<tr>
						<td>集数</td>
						<td>{{rowForm.epNumber}}</td>
					</tr>
					<tr>
						<td>添加时间</td>
						<td>{{rowForm.addTime}}</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--添加-->
		<el-dialog title="添加" :visible.sync="dialogFormVisible" width="600px" @close="closeDialog">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="单集绑定：" prop="bindType">
					<el-select v-model="ruleForm.bindType" filterable clearable placeholder="单集绑定">
						<el-option
								v-for="item in bindTypeOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="绑定短剧：" prop="videoId">
					<el-tag closable @close="handleCloseTagVideo" v-if="videoTitle" style="margin-right: 10px;">{{videoTitle}}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogVideo = true">选择</el-button>
					<el-input v-model="ruleForm.videoId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="绑定小程序：" prop="appId">
					<!--<el-tag closable @close="handleCloseTagApp" v-if="appName" style="margin-right: 10px;">{{appName}}</el-tag>-->
					<!--<el-button type="primary" size="small" @click="isShowDialogApp = true">选择</el-button>-->
					<label>{{appName}}</label>
					<el-input v-model="ruleForm.appId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="小程序页面：" prop="path">
					<el-input v-model="ruleForm.path" disabled></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<video-table-media :visible.sync="isShowDialogVideo" :selectVideo="selectVideo" @videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo"></video-table-media>
		<!--<video-table :visible.sync="isShowDialogVideo" :videoListType="'media'" :selectVideo="selectVideo" @videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo"></video-table>-->
		<!-- <app-table :visible.sync="isShowDialogApp" :selectApp="selectApp"  @appSure="appSure" @cancelDialogApp="cancelDialogApp"></app-table> -->
	</div>
</template>
<script>
// import AppList from '@/components/AppList'
import VideoTableMedia from '@/components/VideoTableMedia'
// import AppTable from '@/components/AppTable'
import {listBind, addBind, delBind } from "@/api/dysvzk/dymedia/binding";
export default {
	components: {
		// AppList,
        VideoTableMedia,
		// AppTable
	},
	data() {
		return {
			formInline: {
				albumId: '',
				appid: localStorage.getItem('appId')
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogInfoVisible: false,
			rowForm: {},
			dialogFormVisible: false,
			bindTypeOptions: [{
				value: 2,
				label: '单集绑定'
			}],
			ruleForm: {
				appId: localStorage.getItem('appId'),
				bindType: '',
				path: "pages/playlet-extension/index",
				videoId: ''
			},
			rules: {
				bindType: [
					{required: true, message: '请选择单集绑定', trigger: 'change'}
				],
				videoId: [
					{required: true, message: '未选择短剧', trigger: 'change'}
				],
				// appId: [
				// 	{required: true, message: '未选择小程序', trigger: 'change'}
				// ],
				path: [
					{required: true, message: '请输入小程序页面', trigger: 'blur'}
				]
			},
			isShowDialogVideo: false,
			selectVideo: {},
			videoTitle: '',
			isShowDialogApp: false,
			selectApp: {},
			appName: localStorage.getItem('appName')
		}
	},
	computed: {},
	watch: {
	},
	mounted: function() {
		this.getTableData()
	},
	methods: {
		search() {
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery(){
			this.$refs['formInline'].resetFields()
			this.getTableData()
		},
		// 从组件获取appid
		// getAppId(data) {
		// 	this.formInline.appid = data
         //    this.getTableData()
		// },
		// 关闭选小程序弹窗
		// cancelDialogApp(data) {
		// 	console.log('cancel')
		// 	this.isShowDialogApp = data
		// },
		// // 确定小程序
		// appSure(data) {
		// 	this.appName = data.name
		// 	this.ruleForm.appId = data.appId
		// 	this.selectApp = data
		// },
		// // 删除所选小程序
		// handleCloseTagApp(tag){
		// 	console.log(tag)
		// 	this.appName = ''
		// 	this.ruleForm.appId = ''
		// 	this.selectApp = {}
		// },
		// 关闭选剧弹窗
		cancelDialogVideo(data) {
			console.log('cancel')
			this.isShowDialogVideo = data
		},
		// 确定剧
		videoSure(data) {
			this.videoTitle = data.title
			this.ruleForm.videoId = data.id
			this.selectVideo = data
		},
		// 删除所选剧
		handleCloseTagVideo(tag){
			console.log(tag)
			this.videoTitle = ''
			this.ruleForm.videoId = ''
			this.selectVideo = {}
		},
		closeDialog(){
			this.$refs['ruleForm'].resetFields()
		},
		// 表格分页
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange (val) {
			this.tableData.pageSize  = val
			this.currentPage = 1
			this.getTableData()
		},
		handleLook(row) {
			this.rowForm = row
			this.dialogInfoVisible = true
		},
		addData() {
			this.dialogFormVisible = true
			this.ruleForm = {
				appId: localStorage.getItem('appId'),
				bindType: '',
				path: "pages/playlet-extension/index",
				videoId: ''
			}
			this.videoTitle = ''
			this.appName = localStorage.getItem('appName')
			this.selectVideo = {}
			this.selectApp = {}
			// if (this.$refs['ruleForm'] !== undefined) {
			//     this.$refs['ruleForm'].resetFields()
			// }
		},
		// 弹框确定
		editDialogSureBtn (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveTableData('add')
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableData () {
			addBind(this.ruleForm).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.getTableData()
					this.dialogFormVisible = false
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 删除
		handleDelete(id) {
			console.log(id)
			delBind({
				infoId: id
			}).then(response => {
				if (response.data.head.flag === 0) {
					if (this.tableData.result.length === 1 && this.currentPage > 1) {
						this.currentPage =  this.currentPage - 1
					}
					this.$refs[id].doClose()
					this.getTableData()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		getTableData() {
			let json2 = {  
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize 
			};
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			console.log(paramJson)
			listBind(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableData = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
	}
}
</script>
